import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useParams } from 'react-router';
import { useT } from '../../i18n';
import { useUi } from '../../store/ui';
import { ApiError, NetworkError, api } from '../../sync/api';
import controls from '../controls.module.css';
import styles from './Auth.module.css';
import { AuthLayout, Field } from './AuthLayout';

/** The link from the mail: a new password, then sign in; every device of the account was signed out. */
export function ResetPassword() {
  const t = useT();
  const navigate = useNavigate();
  const { token = '' } = useParams();
  const showToast = useUi((s) => s.showToast);
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (next !== confirm) {
      setError(t.t('password.mismatch'));
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await api.resetPassword(token, next);
      showToast(t.t('reset.done'));
      navigate('/login', { replace: true });
    } catch (err) {
      if (err instanceof ApiError) setError(err.code === 'RESET_INVALID' ? t.t('reset.invalid') : t.error(err.code));
      else if (err instanceof NetworkError) setError(t.t('auth.serverOffline'));
      else setError(t.error(undefined));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthLayout title={t.t('reset.title')}>
      <form className={styles.form} onSubmit={(e) => void submit(e)}>
        <Field label={t.t('password.next')}>
          <input className={controls.field} type="password" value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" required minLength={10} />
        </Field>
        <Field label={t.t('password.confirm')}>
          <input className={controls.field} type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" required />
        </Field>
        {error ? <p className={styles.error} role="alert">{error}</p> : null}
        <button type="submit" className={`${controls.btn} ${controls.primary}`} disabled={busy}>
          {busy ? t.t('auth.working') : t.t('password.save')}
        </button>
      </form>
      <p className={styles.footer}>
        <Link to="/login" className={styles.link}>
          {t.t('forgot.back')}
        </Link>
      </p>
    </AuthLayout>
  );
}
